
import * as type from './types';

export function getNotificationList(data) {
    return {
        type: type.GET_NOTIFICATION_LIST_REQUESTED,
        data: data,
    }
};